import {
  DragHandle,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { TaskPriorityRef } from '@/tracker/types';

// Ключи приоритетов — как в Яндекс Трекере; незнакомый приоритет — «=»
const ICONS: Record<string, { Icon: typeof DragHandle; color: string }> = {
  blocker: { Icon: KeyboardDoubleArrowUp, color: 'var(--danger-color)' },
  critical: { Icon: KeyboardDoubleArrowUp, color: 'var(--danger-color)' },
  high: { Icon: KeyboardArrowUp, color: 'var(--danger-color)' },
  normal: { Icon: DragHandle, color: 'var(--dark-secondary-color)' },
  low: { Icon: KeyboardArrowDown, color: 'var(--accent-color)' },
  minor: { Icon: KeyboardArrowDown, color: 'var(--accent-color)' },
  trivial: { Icon: KeyboardDoubleArrowDown, color: 'var(--accent-color)' },
};

const PriorityIcon: React.FC<{ priority: TaskPriorityRef }> = ({ priority }) => {
  const { Icon, color } = ICONS[priority.key] ?? ICONS.normal;

  return (
    <Tooltip title={priority.name}>
      <Icon
        aria-label={`Приоритет: ${priority.name}`}
        sx={{ fontSize: 18, color, verticalAlign: 'middle' }}
      />
    </Tooltip>
  );
};

export { PriorityIcon };
